<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" role="doc-toc">
<h1 class="h1f">CONTENTS</h1>
<p class="toc"><a href="#/xhtml/preface"><strong>Preface</strong></a></p>
<p class="toc"><a href="#/xhtml/intro"><strong>Introduction</strong> Waking Up in Conversations</a></p>
<p class="tocline">
</p><p class="tocpart"><a href="#/xhtml/part1">Part I<br/><strong>STORYTELLING CONVERSATIONS</strong><br/>Your Stories Are Not the Truth</a></p>
<p class="tocchap"><a href="#/xhtml/ch1"><strong>1</strong> The Birth of Stories</a></p>
<p class="tocchap"><span href="#/xhtml/ch2" title="Link target outside of Sample"><strong>2</strong> Emotions, Facts, and Stories</span></p>
<p class="tocchap"><span href="#/xhtml/ch3" title="Link target outside of Sample"><strong>3</strong> Opinions and Private Conversations</span></p>
<p class="tocchap"><span href="#/xhtml/ch4" title="Link target outside of Sample"><strong>4</strong> Processing Our Opinions</span></p>
<p class="tocline">
</p><p class="tocpart"><span href="#/xhtml/part2" title="Link target outside of Sample">Part II<br/><strong>COLLABORATIVE CONVERSATIONS</strong><br/>Seek to Understand and Absorb Other Perspectives</span></p>
<p class="tocchap"><span href="#/xhtml/ch5" title="Link target outside of Sample"><strong>5</strong> In Conversation with Others</span></p>
<p class="tocchap"><span href="#/xhtml/ch6" title="Link target outside of Sample"><strong>6</strong> Private Conversations</span></p>
<p class="tocchap"><span href="#/xhtml/ch7" title="Link target outside of Sample"><strong>7</strong> Open Advocacy and Inquiry</span><span aria-label="page viii" id="page_viii" role="doc-pagebreak"></span></p>
<p class="tocline">
</p><p class="tocpart"><span href="#/xhtml/part3" title="Link target outside of Sample">PART III<br/><strong>CREATIVE CONVERSATIONS</strong><br/>Trust Your Intuition</span></p>
<p class="tocchap"><span href="#/xhtml/ch8" title="Link target outside of Sample"><strong>8</strong> From Resignation to Wonder</span></p>
<p class="tocchap"><span href="#/xhtml/ch9" title="Link target outside of Sample"><strong>9</strong> Intuition and Presence</span></p>
<p class="tocchap1"><span href="#/xhtml/ch10" title="Link target outside of Sample"><strong>10</strong> Co-creative Conversations</span></p>
<p class="tocline">
</p><p class="tocpart"><span href="#/xhtml/part4" title="Link target outside of Sample">Part IV<br/><strong>COMMITMENT CONVERSATIONS</strong><br/>Don’t Make Promises You Can’t Keep</span></p>
<p class="tocchap1"><span href="#/xhtml/ch11" title="Link target outside of Sample"><strong>11</strong> The Conversational Bypass</span></p>
<p class="tocchap1"><span href="#/xhtml/ch12" title="Link target outside of Sample"><strong>12</strong> Requests, Offers, and Promises</span></p>
<p class="tocchap1"><span href="#/xhtml/ch13" title="Link target outside of Sample"><strong>13</strong> Recovery Conversations</span></p>
<p class="tocchapt"><span href="#/xhtml/concl" title="Link target outside of Sample"><strong>Conclusion</strong> A Lifelong Journey</span></p>
<p class="toc"><span href="#/xhtml/ref" title="Link target outside of Sample">References</span></p>
<p class="toc"><span href="#/xhtml/ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span href="#/xhtml/author" title="Link target outside of Sample">About the Author</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?475f261a